export const skillsData = [
    'HTML',
    'PHP',
    'React',
    'Figma',
    'Javascript',
    'CSS',
    'React',
    'Node JS',
    'Django',
    'Java',
    'Adobe XD',
    'C',
    'C++',
    'Python',
    'Flutter',
    'Dart',
    'Linux',
    'MongoDB',
    'MySQL',
    'Firebase',
    'Wordpress',
    'After Effects',
    'Illustrator',
    'Photoshop',
    'Docker',
    'Microsoft Office',

]